import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@/api';
import { accountKeys } from '@/lib/queryKeys';
import { GC_TIMES, STALE_TIMES } from '@/lib/constants';

export function useAccountDashboard(id: string | undefined, periodDays = 30) {
  return useQuery({
    queryKey: accountKeys.dashboard(id ?? '', periodDays),
    queryFn: () => analyticsApi.accountDashboard(id!, periodDays),
    enabled: !!id,
    staleTime: STALE_TIMES.long,
    gcTime: GC_TIMES.long,
  });
}
